(function () {
  'use strict';
  var modal = document.querySelector('#htlQuizModal[data-htl-experience]');
  function update() {
    if (!modal) return;
    var active = modal.querySelector('.htl-quiz-screen.is-active');
    var controls = document.getElementById('htlRefineControls');
    if (controls) controls.hidden = !(active && active.hasAttribute('data-step') && Number(active.getAttribute('data-step')) >= 3);
    var chosen = modal.querySelector('.htl-quiz-options[data-question="spaceMode"] .is-selected');
    var measured = !!(chosen && chosen.getAttribute('data-value') === 'strict');
    var measurements = document.getElementById('htlSpaceMeasurements');
    var skip = document.getElementById('htlSkipInitialMeasurements');
    if (measurements) measurements.hidden = !measured;
    if (skip) skip.hidden = !measured;
    if (!measured) { var error = document.getElementById('htlSpaceError'); if (error) error.hidden = true; }
    modal.querySelectorAll('.htl-quiz-options').forEach(function (group) {
      group.setAttribute('role', 'group');
      var screen = group.closest('.htl-quiz-screen');
      var heading = screen && screen.querySelector('.htl-quiz-title');
      if (heading) {
        if (!heading.id) heading.id = 'htl-question-' + screen.getAttribute('data-step');
        group.setAttribute('aria-labelledby', heading.id);
      }
      if (screen) {
        var kicker = screen.querySelector('.htl-quiz-kicker');
        var pattern = modal.getAttribute('data-htl-step-pattern');
        var step = Number(screen.getAttribute('data-step'));
        var total = 4;
        var current = step + 1;
        if (kicker && pattern) kicker.textContent = step < 3 ? pattern.replace('{current}', current).replace('{total}', total) : modal.getAttribute('data-htl-optional-pattern');
      }
      group.querySelectorAll('.htl-quiz-option').forEach(function (option) {
        option.setAttribute('aria-pressed', String(option.classList.contains('is-selected')));
      });
      if (!screen) return;
      var next = screen.querySelector('[onclick*="htlNextStep"], [onclick*="htlSpaceChoiceNext"]');
      if (next) next.disabled = !group.querySelector('.is-selected');
    });
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-htl-launch-finder]');
    if (trigger) {
      event.preventDefault();
      if (modal && typeof window.htlOpenQuiz === 'function') window.htlOpenQuiz();
      else {
        var destination = new URL(trigger.href, location.origin);
        var source = new URLSearchParams(location.search);
        ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','gbraid','wbraid','fbclid','campaign_id','adset_id','ad_id','preview_theme_id'].forEach(function (key) {
          if (source.has(key)) destination.searchParams.set(key, source.get(key));
        });
        location.assign(destination.href);
      }
    }
    update();
  });
  var original = window.htlShowStep;
  if (modal && typeof original === 'function') {
    window.htlShowStep = function () { var value = original.apply(this, arguments); update(); return value; };
  }
  document.addEventListener('htl:finder-results', update);
  var showLead = window.htlShowLead;
  if (modal && typeof showLead === 'function') {
    window.htlShowLead = function () { var value = showLead.apply(this, arguments); update(); return value; };
  }
  update();
})();


